import { render, staticRenderFns } from "./videopicker.vue?vue&type=template&id=b529004c&scoped=true&"
import script from "./videopicker.vue?vue&type=script&lang=js&"
export * from "./videopicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b529004c",
  null
  
)

export default component.exports